import { computed, Injectable, signal, WritableSignal } from '@angular/core';
import { StorageModel } from '../models/storage.model';

@Injectable({
  providedIn: 'root'
})
export class SettingHelper {

  /**
   * Saved data store
   */
  readonly store: WritableSignal<StorageModel> = signal(new StorageModel(), { equal: () => false });

  /**
   * Indexer
   */
  readonly indexer = computed(() => this.store().settings.indexer);

  /**
   * Graphql provider
   */
  readonly graphql = computed(() => this.store().settings.graphql);


  /**
   * Jsonrpc provider
   */
  readonly jsonrpc = computed(() => this.store().settings.jsonrpc);

  /**
   * List of indexers
   */
  private indexers = [
    { id: 'graphql', name: 'GraphQL' },
    { id: 'jsonrpc', name: 'JSON-RPC' },
  ];

  /**
   * List of graphql providers
   */
  private graphql_providers = [
    { id: 'default', name: 'Default' },
    { id: 'foundation', name: 'Foundation' },
  ];

  /**
   * List of jsonrpc providers
   */
  private jsonrpc_providers = [
    { id: 'default', name: 'Default' },
    { id: 'foundation', name: 'Foundation' },
    { id: 'suiscan', name: 'Suiscan' },
    { id: 'publicnode', name: 'PublicNode' },
    { id: 'blastapi', name: 'BlastAPI' },
  ];

  /**
   * Saved storage
   */
  private storage = new StorageModel();

  /**
   * Get list of indexers
   */
  listIndexers() {
    return this.indexers;
  }

  /**
   * Get list of graphql providers
   */
  listGraphqlProviders() {
    return this.graphql_providers;
  }

  /**
   * Get list of graphql providers
   */
  listJsonrpcProviders() {
    return this.jsonrpc_providers;
  }

  /**
   * Read storage
   */
  readStorage() {
    // Read indexer
    let indexer = this.indexers.find(x => x.id == localStorage.getItem('kyovy.indexer'));
    this.storage.settings.indexer = indexer ? indexer.id : this.indexers[0].id;

    // Read graphql provider
    let graphql = this.graphql_providers.find(x => x.id == localStorage.getItem('kyovy.graphql'));
    this.storage.settings.graphql = graphql ? graphql.id : this.graphql_providers[0].id;

    // Read jsonrpc provider
    let jsonrpc = this.jsonrpc_providers.find(x => x.id == localStorage.getItem('kyovy.jsonrpc'));
    this.storage.settings.jsonrpc = jsonrpc ? jsonrpc.id : this.jsonrpc_providers[0].id;

    this.store.set(this.storage);
  }

  /**
   * Change indexer
   * 
   * @param indexer
   */
  setIndexer(indexer: string) {
    localStorage.setItem('kyovy.indexer', indexer);
    this.readStorage();
  }

  /**
   * Change graphql provider
   * 
   * @param provider
   */
  setGraphqlProvider(provider: string) {
    localStorage.setItem('kyovy.graphql', provider);
    this.readStorage();
  }

  /**
   * Change jsonrpc provider
   * 
   * @param provider
   */
  setJsonrpcProvider(provider: string) {
    localStorage.setItem('kyovy.jsonrpc', provider);
    this.readStorage();
  }
}
